export const selectValues = ['0,00', '0,50', '1,00', '1,50', '2,00', '2,50', '3,00'];
